import { DocumentViewerLoading } from "./DocumentViewerLoading";

/** Wert für `DocumentViewer.renderLoading` in m1member. */
export const renderDocumentViewerLoading = () => <DocumentViewerLoading />;
